
import FiltroProfesiones from '@/model/filtros/FiltroProfesiones';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { agrupacionesInscStore } from '@/store/AgrupacionesInscStore';
import Agrupacion from '@/model/Agrupacion';

@Options({
  components: {},
  name: 'FiltrosProfesiones',
})
export default class FiltrosProfesiones extends Vue {
  async mounted() {
    if (agrupacionesInscStore.getState().length === 0) {
      agrupacionesInscStore.loadAgrupaciones();
    }
  }

  @Prop()
  private filtro!: FiltroProfesiones;

  private agrupaciones: Agrupacion[] = agrupacionesInscStore.getState();

  form(): Vue & { validate: () => boolean; resetValidation(): void } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      resetValidation(): void;
    };
  }

  validate() {
    return this.form().validate();
  }
  filterFn(val: string, update: (arg0: { (): void; (): void }) => void) {
    if (val === '') {
      update(() => {
        this.agrupaciones = agrupacionesInscStore.getState();
      });
      return;
    }

    update(() => {
      const needle = val.toUpperCase();
      this.agrupaciones = agrupacionesInscStore.getState().filter((v) => v.descripcion.toUpperCase().indexOf(needle) > -1);
    });
  }

  resetValidation() {
    this.form().resetValidation();
  }
}
